import { ReactElement } from 'react';

import { Stack } from '@mui/material';
import { FormProvider } from 'react-hook-form';

import { logger } from '@/utils';

import { MainContainer, ProductTabs } from '../components';
import { useSubscriptionForm } from '../hooks';

export const Subscription = (): ReactElement => {
  const form = useSubscriptionForm();

  const handleSubmit = form.handleSubmit((formData) =>
    logger.log('Data: ', formData),
  );

  return (
    <MainContainer>
      <FormProvider {...form}>
        <Stack component="form" spacing={2} onSubmit={handleSubmit}>
          <ProductTabs />
        </Stack>
      </FormProvider>
    </MainContainer>
  );
};
